const locationConfigurationsList = (eventType) => eventType.location_configurations || eventType.locationConfigurations

const isLocationOnMemberships = (eventType) => {
  const poolingType = eventType.pooling_type ?? eventType.poolingType
  if (poolingType === 'round_robin') { return true }

  const ignoreConfigs = eventType.ignore_location_configurations ?? eventType.ignoreLocationConfigurations
  if (ignoreConfigs) { return true }

  return false
}

export const getEventTypeLocation = (eventType) => {
  const et = eventType ?? {}

  // One-off meetings
  if (et.locationType) return et.locationType

  if (et.location_type && et.location_type !== null) {
    return et.location_type
  }

  if (isLocationOnMemberships(et)) { return null }

  return locationConfigurationsList(et)?.[0]?.kind || null
}

export const useEventTypeLocation = (eventType) => getEventTypeLocation(eventType)
